<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="VALUTA.SIFRA.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtNaziv"
              formControlName="Naziv"
              #focusElement
              [MaxLength]="30"
              [ngClass]="{'is-invalid' : submitted && fc.Naziv.invalid}"
              [Label]="'VRSTAIZOSTANKA.NAZIV.SINGULAR'"
              >
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                  <span *ngFor="let validation of errorMessages.Naziv">
                    <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="VALUTA.SIFRA.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtOznaka"
              formControlName="Oznaka"
              #focusElement
              [MaxLength]="5"
              [ngClass]="{'is-invalid' : submitted && fc.Oznaka.invalid}"
              [Label]="'VRSTAIZOSTANKA.OZNAKA.SINGULAR'"
              >
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Oznaka.invalid">
                  <span *ngFor="let validation of errorMessages.Oznaka">
                    <span class="error-message" *ngIf="fc.Oznaka.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>
          </div>
        </div>
          <div class="form-group row">
              <div class="col-md-12">
                  <yt-number-input-v3 
                      name="txtSati" 
                      [Label]="'VRSTAIZOSTANKA.SATI.SINGULAR'"
                      formControlName="Sati">
                  </yt-number-input-v3>
              </div>
          </div>
      
      </div>
    </div>
  </div>
</form>
